import api from "../../services/api";

export const generateBasePlug = async ({ body }) => {
  return await api.post(`integracao/v2/mapa`, body);
};

export const getMapsPlug = async ({ params }) => {
  return await api.get(`integracao/v2/mapa${params}`);
};

export const liberationToPanel = async ({
  body,
  qyonHubPost,
  isAccountant = true,
}) => {
  return await api.post(
    `integracao/v2/mapa/painel?qyonHubPost=${qyonHubPost}&isAccountant=${isAccountant}`,
    body
  );
};

export const liberationToBPO = async ({ body }) => {
  return await api.post(`integracao/v2/mapa/bpo`, body);
};

export const createCustomerPlug = async ({ body, qyonHubPost }) => {
  return await api.post(
    `integracao/v2/cliente?qyonHubPost=${qyonHubPost}`,
    body
  );
};

export const getCustomersPlug = async ({ params }) => {
  return await api.get(`integracao/v2/cliente${params}`);
};

export const createProspectCrm = async ({ body }) => {
  return await api.post(`integracao/v2/crm/prospect`, body);
};

export const createCustomerCrm = async ({ body }) => {
  return await api.post(`integracao/v2/crm/cliente`, body);
};

export const createPromocode = async ({ body }) => {
  return await api.post(`integracao/v2/promocode`, body);
};

export const createPromoter = async ({ body }) => {
  return await api.post(`integracao/v2/promotor`, body);
};

export const getPromotionalCode = async ({ params }) => {
  return await api.get(`integracao/v2/codigopromocional${params}`);
};

export const inativePromotionalCode = async ({ code }) => {
  return await api.put(`integracao/v2/codigopromocional/${code}`);
};

export const createFenaconCustomer = async ({ body }) => {
  return await api.post(`integracao/v2/fenaconcliente`, body);
};

export const updateAndSyncContract = async ({ body }) => {
  return await api.post(`v1/contrato/sync`, body);
};
